import React, { useState } from "react";
import { AgentsList } from "./AgentsList";
import { Workflows } from "./Workflows";
import { AgentsSidebar } from "./agent/AgentsSidebar";


export const Agents = () => {
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "agents-list");
  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>
      <AgentsSidebar
        show={showSidebar}
        defaultSelectedTab={selectedTab}
        onNavItemClicked={(navItem) => {
          console.log("!!! NAV ITEM CLICKED: ", navItem);

          setSelectedTab(navItem);
        }}
        onClosed={(closed) => {
          console.log("!!! CLOSED", closed);
        }}
        onToggle={() => {
          setShowSidebar(!showSidebar);
        }}
      />

      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - ${showSidebar ? "250px" : "0px"})`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "20px" }}>
          <AgentsList
            show={selectedTab === "agents-list"}
            onSelectTab={(tab) => {
              window.history.replaceState(null, null, `#${tab}`);
              setSelectedTab(tab);
            }} />
          <Workflows
            show={selectedTab === "workflows"}
            onSelectTab={(tab) => {
              window.history.replaceState(null, null, `#${tab}`);
              setSelectedTab(tab);
            }} />
        </div>
      </div>
    </div>
  )

};

export default Agents;
